<p-dialog header="{{ headerTitle }}" [(visible)]="displayOpportunitySelectionDialog" [modal]="true" [responsive]="true" [style]="{ width: '85vw' }" (onHide)="cancel()" [draggable]="false" [baseZIndex]="3">
  <div class="p-col-12">
      <p-menubar [model]="menuItems">
          <ng-template pTemplate="start" style="width: 100%">
              <span class="p-input-icon-left" style="float: right; margin: 2px 5px 0px 5px">
                  <i class="pi pi-search"></i>
                  <input pInputText type="text" style="height: 30px; font-size: 1rem; width: 100%" (input)="onSearchInput($event)" placeholder="Search..." />
              </span>
          </ng-template>
      </p-menubar>
  </div>
  <div class="card">
      <p-table [value]="rowGroupMetadata" [columns]="savedListColsVM" [scrollable]="true" 
      [selectionMode]="'single'" [(selection)]="selectedOpportunity" dataKey="id"
       styleClass="p-datatable-gridlines" [paginator]="true" [resizableColumns]="true" 
       responsiveLayout="scroll" [rows]="pageSize" [lazy]="true"
        [rowsPerPageOptions]="tableShowMore" [totalRecords]="totalRecords" 
        [showCurrentPageReport]="true" [(first)]="firstPage" 
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
         [(contextMenuSelection)]="selectedOpportunity" (onPage)="getData($event)"
          (onSort)="onSortColumn($event)">
          <ng-template pTemplate="header" let-columns>
              <tr>
                  <ng-container *ngFor="let col of columns">
                      <th *ngIf="col.enabled" [pSortableColumn]="col.columnName" style="border-right: 1px solid var(--primary-color)" pResizableColumn>
                          {{ col.name }}{{ col?.value?.length }}
                          <p-sortIcon [field]="col.columnName" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"> </p-sortIcon>
                      </th>
                  </ng-container>
              </tr>
          </ng-template>

          <ng-template pTemplate="body" let-rowData let-columns="columns">
              <tr [pSelectableRow]="rowData">
                  <ng-container *ngFor="let col of columns">
                      <td *ngIf="col.enabled">
                          <ng-container *ngIf="col.fieldDataType === 'DateTime'; else otherTypes">
                              {{ rowData[col.columnName] | date: "dd/MM/yyyy" }}
                          </ng-container>
                          <ng-template #otherTypes>
                              <ng-container *ngIf="col.columnName === 'totalAmount'; else defaultTemplate">
                                  {{ rowData[col.columnName] || 0 | customNumberFormat: fractionDigits | currencySymbol }}
                              </ng-container>
                          </ng-template>
                          <ng-template #defaultTemplate>
                              {{ rowData[col.columnName] || "" }}
                          </ng-template>
                      </td>
                  </ng-container>
              </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
              <tr>
                  <td colspan="10" style="text-align: center">No data found.</td>
              </tr>
          </ng-template>
      </p-table>
  </div>
  <p-footer>
      <button type="button" pButton (click)="cancel()" label="Cancel" class="p-button-secondary"></button>
      <button type="button" pButton (click)="save()" label="Save"></button>
  </p-footer>
</p-dialog>

<app-shared-column-setting-modal [displayColumnSettings]="displayColumnSettings" moduleName="Opportunity" 
[disabledLabelNames]="disabledLabelNames" [selectedView]="selectedView" [settingsObj]="columnSettingsN" 
[modal]="true" [channelId]="accountChannelId" (savedColumnSettings)="savedColumnSettings()" 
(cancelColumnSettings)="cancelColumnSettings()"> </app-shared-column-setting-modal>
